/**
 * TagManagementSection Component
 *
 * Handles the tag management functionality for option fields
 */

import * as React from 'react';
import { TagManagerProps } from '../../types';
import { TagManager } from '../TagManager';

interface TagManagementSectionProps {
	tagManagerProps: TagManagerProps;
	isOptionField: boolean;
	onValidationTrigger?: (questionIndex: number) => Promise<boolean>;
	onModalCreateTag: (handler: (() => void) | null) => void;
	onModalEditTag: (handler: (() => void) | null) => void;
}

export const TagManagementSection: React.FC<TagManagementSectionProps> = React.memo(
	({ tagManagerProps, isOptionField, onValidationTrigger, onModalCreateTag, onModalEditTag }) => {
		if (!tagManagerProps || !isOptionField) {
			return null;
		}

		return (
			<TagManager
				{...tagManagerProps}
				onValidationTrigger={onValidationTrigger}
				onModalCreateTag={onModalCreateTag}
				onModalEditTag={onModalEditTag}
			/>
		);
	}
);

TagManagementSection.displayName = 'TagManagementSection';
